import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AgGridModule } from 'ag-grid-angular';
import { ColDef, RowClassRules } from 'ag-grid-enterprise';
import { AG_GRID_LOCALE_DE } from 'src/app/_helpers/aggrid.locale.de';
import { DeliveryNote } from 'src/app/_models';
import { DeliveryNoteService } from 'src/app/_services';
import { AgGridThemeService } from 'src/app/_services/ag-grid-theme.service';
import { environment } from 'src/environments/environment';
import { AgGridGenericLinkRenderer } from '../_shared/ag-grid-renderer/ag-grid-generic-link.component';

@Component({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FontAwesomeModule,
    AgGridModule,
  ],
  selector: 'hawk-delivery-note-show',
  templateUrl: './delivery-note-show.component.html',
  styleUrls: ['./delivery-note-show.component.scss'],
  host: {
    class: 'app-page'
  }
})
export class DeliveryNoteShowComponent implements OnInit {
  constructor(
    private deliveryNoteService: DeliveryNoteService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  public hawkTheme = inject(AgGridThemeService).getTheme();
  public deliveryNoteId: number | String | string;
  public deliveryNote: DeliveryNote;
  public articles: any[];
  env = environment;

  public locale = AG_GRID_LOCALE_DE;
  public isCheckingShipcloudTrackingStatus: boolean = false;
  public rowSelection: "single" | "multiple" = "multiple"
  public rowClassRules: RowClassRules = {
    // if tech on site, color row
    'tech-on-site': (params) => {
      if (params?.data === undefined) return "...";
      return params.data.tech_on_site
    },
  }

  public defaultColDef: ColDef = {
    filter: true,
    flex: 1
  }

  public colDefs: ColDef[] = [
    {
      field: "rma",
      headerName: 'RMA',
      cellRenderer: AgGridGenericLinkRenderer,
      cellRendererParams: {
        routerLink: ['/', 'artikel', '@id'],
        labelFromData: true,
        dataKey: 'rma'
      },
      maxWidth: 200
    },
    {
      field: "description",
      headerName: 'Bezeichnung',
      rowGroup: true,
    },
    {
      field: "serial_number",
      headerName: 'Seriennummer',
    },
    {
      field: "bad_part",
      headerName: 'BadPart',
      maxWidth: 150
    },
  ]

  ngOnInit(): void {
    this.deliveryNoteId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.loadDeliveryNote();
    this.loadArticles();
  }

  private loadArticles() {
    this.deliveryNoteService.articles(this.deliveryNoteId).subscribe(
      {
        next: (response: any) => {
          this.articles = response;
        },
        error: (error) => {
          console.log('error', error);
        }
      }
    )
  }

  public createRetoure() {
    this.deliveryNoteService.createRetoure(this.deliveryNoteId).subscribe(
      {
        next: (response: any) => {
          this.router.navigateByUrl(`/retoure/${response.id}`);
        },
        error: (error) => {
          console.log('error', error);
        }
      }
    )
  }

  private loadDeliveryNote() {
    this.deliveryNoteService.show(this.deliveryNoteId).subscribe(
      {
        next: (response: DeliveryNote) => {
          this.deliveryNote = response;
        },
        error: (error) => {
          console.log('error', error);
        }
      }
    )
  }

  public onDelete() {
    if(this.deliveryNote.status != 'PREPARED') return;

    if(confirm('Möchten Sie das Lager wirklich löschen?')) {
      this.deliveryNoteService.delete(this.deliveryNoteId).subscribe(
        {
          next: () => {
            this.router.navigateByUrl('/lieferscheine/suche/index');
          },
          error: (error) => {
            console.log('errors', error);
          }
        }
      )
    }
  }

  public checkShipcloudTrackingStatus() {
    this.isCheckingShipcloudTrackingStatus = true;
    this.deliveryNoteService.checkShipcloudTrackingStatus(this.deliveryNoteId).subscribe(
      {
        next: (response) => {
          this.isCheckingShipcloudTrackingStatus = false;
          this.deliveryNote = response;
        },
        error: (error) => {
          alert(`Errors: ${error}`);
          console.log('error', error);
          this.isCheckingShipcloudTrackingStatus = false;
        }
      }
    )
  }

}
